import { ResolverTag } from '@ps/web-core-enums';
import { StarsButton, Translation, useResolver } from '@ps/web-shared-components';
import { StarsInfo } from '@ps/web-shared-ui';
import React from 'react';

import {
  TXTCLI_Download,
  TXTWCL_Please_login_to_our_downloadab_ELL_1
} from './TournamentMoneyNonPokerContent.messages.json';
import styles from './TournamentMoneyNonPokerContent.scss';

const TournamentMoneyNonPokerContent: React.FC = () => {
  const downloadPageLink = useResolver(ResolverTag.PSDownloadPage);

  return (
    <>
      <StarsInfo className={styles.message}>
        <Translation {...TXTWCL_Please_login_to_our_downloadab_ELL_1} />
      </StarsInfo>
      <StarsButton
        className={styles.button}
        target="_blank"
        rel="noopener noreferrer"
        href={downloadPageLink}
        disabled={!downloadPageLink}
        translation={TXTCLI_Download}
      />
    </>
  );
};
export default TournamentMoneyNonPokerContent;
